const VISITOR_KEY = "nbti:analytics:v2:visitor";
const VISIT_KEY = "nbti:analytics:v2:visit";
const VISIT_COUNT_KEY = "nbti:analytics:v2:visit-count";

function createId(prefix: string) {
  const value = typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID()
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
  return `${prefix}_${value}`;
}

function readOrCreate(storage: Storage, key: string, prefix: string) {
  let value = storage.getItem(key);
  if (!value) {
    value = createId(prefix);
  }
  storage.setItem(key, value);
  return value;
}

function deviceType() {
  const ua = navigator.userAgent;
  if (/iPad|Tablet/i.test(ua)) return "tablet";
  if (/Mobi|Android|iPhone/i.test(ua)) return "mobile";
  return "desktop";
}

function browserName() {
  const ua = navigator.userAgent;
  if (/MicroMessenger/i.test(ua)) return "WeChat";
  if (/Edg\//i.test(ua)) return "Edge";
  if (/OPR\//i.test(ua)) return "Opera";
  if (/Chrome\//i.test(ua)) return "Chrome";
  if (/Safari\//i.test(ua) && !/Chrome\//i.test(ua)) return "Safari";
  if (/Firefox\//i.test(ua)) return "Firefox";
  return "Other";
}

export interface AnalyticsContext {
  visitorId: string;
  visitId: string;
  visitNumber: number;
  isNewVisit: boolean;
  device: string;
  browser: string;
}

let analyticsContext: AnalyticsContext | undefined;

export function getAnalyticsContext() {
  if (analyticsContext) return analyticsContext;
  const hadVisit = Boolean(sessionStorage.getItem(VISIT_KEY));
  const visitorId = readOrCreate(localStorage, VISITOR_KEY, "visitor");
  const visitId = readOrCreate(sessionStorage, VISIT_KEY, "visit");
  const visitNumber = hadVisit
    ? Number(sessionStorage.getItem(VISIT_COUNT_KEY) || "1")
    : Number(localStorage.getItem(VISIT_COUNT_KEY) || "0") + 1;
  if (!hadVisit) {
    localStorage.setItem(VISIT_COUNT_KEY, String(visitNumber));
    sessionStorage.setItem(VISIT_COUNT_KEY, String(visitNumber));
  }
  analyticsContext = { visitorId, visitId, visitNumber, isNewVisit: !hadVisit, device: deviceType(), browser: browserName() };
  return analyticsContext;
}

export interface AnalyticsEvent {
  event_name: string;
  properties: Record<string, unknown>;
  created_at: string;
  visitor_id: string;
  visit_id: string;
  visit_number: number;
  device: string;
  browser: string;
}

export function sendAnalyticsEvent(event: AnalyticsEvent) {
  void fetch("/api/events", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(event),
    keepalive: true,
  }).catch(() => {
    // The local queue remains available when the analytics service is offline.
  });
}
